import React, { useCallback, useEffect, useState } from 'react'
import { CAlert, CButton, CCol, CRow } from '@coreui/react-pro'
import GameHomeService from 'src/service/GameHomeService'
import Loader from 'src/components/Loader'
import SetupProgressCard from './SetupProgressCard'
import NextStepCard from './NextStepCard'
import LaunchEssentialsGrid from './LaunchEssentialsGrid'
import QuickActionsCard from './QuickActionsCard'
import GameInformationCard from './GameInformationCard'
import NeedHelpCard from './NeedHelpCard'
import StepperBar from '../SetupProgress/StepperBar'
import ActivateGameModal from './ActivateGameModal'

const GameHome = () => {
  const [progress, setProgress] = useState(null)
  const [progressUpdated, setProgressUpdated] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [showActivateModal, setShowActivateModal] = useState(false)

  const fetchProgress = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const result = await GameHomeService.getSetupProgress()
      setProgress(result.data)
      setProgressUpdated(result.data_updated)
    } catch (e) {
      console.error('Error fetching setup progress:', e)
      setError(e?.message || 'Unable to load Game Home. Please try again.')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchProgress()
  }, [fetchProgress])

  if (loading) {
    return <Loader />
  }

  console.log('GameHome progress:', progressUpdated)

  if (error) {
    return (
      <CAlert color="danger" className="d-flex justify-content-between align-items-center">
        {error}
        <CButton color="danger" variant="outline" size="sm" onClick={fetchProgress}>
          Retry
        </CButton>
      </CAlert>
    )
  }

  if (!progress || !progress.steps?.length) {
    return <CAlert color="info">No setup steps found for this game.</CAlert>
  }
  if (!progressUpdated || !progressUpdated.steps?.length) {
    return <CAlert color="info">No setup steps found for this game.</CAlert>
  }

  const sortedSteps = [...progress.steps].sort((a, b) => a.order - b.order)
  const nextStep = progress.next_step
    ? sortedSteps.find((step) => step.key === progress.next_step.key)
    : null

  const sortedStepsUpdated = [...progressUpdated.steps].sort((a, b) => a.order - b.order)
  const nextStepUpdated = progressUpdated.next_step
    ? sortedStepsUpdated.find((step) => step.key === progressUpdated.next_step.key)
    : null

  return (
    <>
      {/* <StepperBar activeStepKey="game_structure" /> */}
      <CRow>
        <CCol xs={12} lg={8}>
          <SetupProgressCard
            steps={sortedStepsUpdated}
            counts={progressUpdated.counts}
            percentComplete={progressUpdated.percent_complete}
            totalSteps={progressUpdated.total_steps}
          />
          <NextStepCard nextStep={nextStep} onActivateGame={() => setShowActivateModal(true)} />
          <LaunchEssentialsGrid steps={sortedSteps} />
        </CCol>
        <CCol xs={12} lg={4}>
          <QuickActionsCard steps={sortedSteps} onActivateGame={() => setShowActivateModal(true)} />
          <GameInformationCard gameInformation={progress.game_information} />
          <NeedHelpCard />
        </CCol>
      </CRow>
      {/* <CAlert color="info">
        Tip: You can save your progress and come back anytime. All changes are saved automatically.
      </CAlert> */}
      <ActivateGameModal
        visible={showActivateModal}
        onClose={() => setShowActivateModal(false)}
        onActivated={fetchProgress}
      />
    </>
  )
}

export default GameHome
